import { useTranslation } from "react-i18next";
import { TeamSection } from "@/components/project/TeamSection";
import { IntegrationsSection } from "@/components/project/IntegrationsSection";
import { ProjectSettingsSection } from "@/components/project/ProjectSettingsSection";
import { ProjectCartridgesSection } from "@/components/project/ProjectCartridgesSection";
import { CliConnectSection } from "@/components/project/CliConnectSection";

interface ConfigPanelProps {
  projectSlug: string;
}

export function ConfigPanel({ projectSlug }: ConfigPanelProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <section>
        <h2 className="mb-4 text-lg font-semibold">
          {t("projectPortal.config.teamHeading")}
        </h2>
        <TeamSection projectSlug={projectSlug} />
      </section>

      <section>
        <h2 className="mb-4 text-lg font-semibold">
          {t("projectPortal.config.integrationsHeading")}
        </h2>
        <IntegrationsSection />
      </section>

      <section>
        <h2 className="mb-4 text-lg font-semibold">
          {t("projectPortal.config.governanceHeading")}
        </h2>
        <ProjectCartridgesSection projectSlug={projectSlug} />
      </section>

      <section>
        <h2 className="mb-4 text-lg font-semibold">
          {t("projectPortal.config.settingsHeading")}
        </h2>
        <ProjectSettingsSection projectSlug={projectSlug} />
      </section>

      <section>
        <h2 className="mb-4 text-lg font-semibold">
          {t("projectPortal.config.cliHeading")}
        </h2>
        <CliConnectSection projectSlug={projectSlug} />
      </section>
    </div>
  );
}
